var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 12
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#898A8F",
  fillRule: "nonzero",
  d: "M1 10.6666667C1 11.4 1.6 12 2.33333333 12H7.6666667C8.4 12 9 11.4 9 10.6666667V2.66666667H1v8.00000003zM2.33333333 4H7.6666667v6.6666667H2.33333333V4zM7.3333333.66666667L6.66666667 0H3.33333333l-.66666666.66666667H.33333333V2H9.6666667V.66666667H7.3333333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3-2h16v16H-3z"
}))));
export default __webpack_public_path__ + "static/media/trash.1627e65f.svg";
export { SvgComponent as ReactComponent };